import(/* webpackMode: "eager", webpackExports: ["BlogOverview"] */ "/tmp/8dee7fca0d68e48/app/[locale]/blog/BlogOverview.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/app/[locale]/blog/page.module.css");
